import {
  flex,
  mt,
  width,
  CenteredLoading,
  CheckEmojiDivider,
} from '@openeducation/oe-rn-components';
import { selectedLiveClassFeedbackLessonIdAtom } from '@openeducation/oe-rn-jotai-atoms';
import { styled } from '@openeducation/oe-rn-themes';
import { useAtomValue } from 'jotai';
import * as React from 'react';
import { View } from 'react-native';
import { Divider as DividerBase } from 'react-native-paper';

import { useStudentPendingFeedback } from './use-student-pending-feedback';
import PCFeedbackFormReadOnly from '../../molecules/pc-feedback-form-read-only/pc-feedback-form-read-only';
import { PCCommonFeedback } from '../../organisms/pc-common-feedback/pc-common-feedback';
import { PCMessage as PCMessageBase } from '../../organisms/pc-message/pc-message';
import { SelectedPCFeedbackPanel } from '../../organisms/selected-pc-feedback-panel/selected-pc-feedback-panel';
import { PortalLayout } from '../../templates/portal-layout/portal-layout';

export interface StudentFeedbackProps {
  teacherId: number;
  studentId: number;
  classroomId: number;
}

export const StudentPendingFeedback = ({
  teacherId,
  studentId,
  classroomId,
}: StudentFeedbackProps) => {
  const {
    isLoading,
    pendingFeedback,
    liveClassFeedback,
    liveClassLessons,
    setCurrentLiveClassLesson,
    setSelectedFeedback,
  } = useStudentPendingFeedback(teacherId, studentId, classroomId);
  const studentLessonId = useAtomValue(selectedLiveClassFeedbackLessonIdAtom);
  const lessonId = liveClassFeedback?.lessonId || studentLessonId;

  React.useEffect(() => {
    if (!lessonId) return;
    setCurrentLiveClassLesson(lessonId);
  }, [liveClassLessons, lessonId, setCurrentLiveClassLesson]);

  React.useEffect(() => {
    if (!pendingFeedback) return;

    setSelectedFeedback(pendingFeedback, liveClassFeedback);
  }, [pendingFeedback, liveClassFeedback, setSelectedFeedback]);

  if (isLoading) return <CenteredLoading size={100} style={mt(50)} />;

  if (!pendingFeedback || pendingFeedback.teacherFeedback)
    return (
      <PortalLayout>
        <View style={flex('flex-row', 'justify-content-center')}>
          <PCMessage
            title="The feedback for this class was already sent by the teacher."
            divider={<CheckEmojiDivider />}
          />
        </View>
      </PortalLayout>
    );

  return (
    <PCCommonFeedback panelStyle={[width('100%')]}>
      <>
        <SelectedPCFeedbackPanel />
        <Divider />
        <PCFeedbackFormReadOnly />
      </>
    </PCCommonFeedback>
  );
};

const PCMessage = styled(PCMessageBase)`
  background-color: red;
  border: 1px blue solid;
`;

const Divider = styled(DividerBase)`
  margin-top: 40px;
  background-color: ${({ theme }) => theme.color.lightPrimary};
`;

export default StudentPendingFeedback;
